import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Flame, Zap } from 'lucide-react';
import { useMotionBudget } from '../../app/hooks/useMotionBudget';
interface ComboIndicatorProps {
  combo: number;
}
export function ComboIndicator({
  combo
}: ComboIndicatorProps) {
  const {
    shouldAnimate
  } = useMotionBudget();
  const [isBumping, setIsBumping] = useState(false);
  useEffect(() => {
    if (combo > 1) {
      setIsBumping(true);
      const timer = setTimeout(() => setIsBumping(false), 300);
      return () => clearTimeout(timer);
    }
  }, [combo]);
  if (combo < 2) return null;
  // Determine visual style based on combo size
  const isHot = combo >= 5;
  const isOnFire = combo >= 10;
  const colors = isOnFire ? 'bg-purple-500 text-white border-purple-600' : isHot ? 'bg-orange-500 text-white border-orange-600' : 'bg-orange-100 text-orange-700 border-orange-200';
  const Icon = isOnFire ? Zap : Flame;
  return <AnimatePresence data-id="element-2146">
      <motion.div initial={shouldAnimate ? {
      opacity: 0,
      y: -10,
      scale: 0.8
    } : false} animate={shouldAnimate ? {
      opacity: 1,
      y: 0,
      scale: isBumping ? 1.1 : 1
    } : false} exit={shouldAnimate ? {
      opacity: 0,
      scale: 0.8
    } : false} transition={{
      type: 'spring',
      stiffness: 500,
      damping: 25
    }} className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border shadow-sm font-bold ${colors}`} data-id="element-2147">
        <Icon className={`w-4 h-4 ${isBumping && shouldAnimate ? 'animate-bounce' : ''}`} fill={isHot || isOnFire ? 'currentColor' : 'none'} data-id="element-2148" />
        <span data-id="element-2149">{combo}x Combo!</span>
      </motion.div>
    </AnimatePresence>;
}